module.exports = __webpack_public_path__ + "static/media/productHeaderImg.0d357376.png";